import qs from 'query-string';

export default function samlInit(loginOptionResponse, additionalQueryParams) {
  const { clientId, loginOptions } = loginOptionResponse;
  const queryString = qs.stringify(additionalQueryParams);

  const urlSegments = ['/api', 'login', clientId];

  if (loginOptions.directoryId) {
    urlSegments.push(loginOptions.directoryId);
  }

  urlSegments.push('saml');

  // login.justsift.com/api/login/:clientId/:directoryId?/saml
  const baseUrl = urlSegments.join('/');

  window.location.href = `${baseUrl}?${queryString}`;
}
